<template>
    <div>
        <v-data-table
            :items="basket_active"
            :class="basket_active.length > 0 ? 'basket-table' : 'basket-table-none'"
            hide-actions
            :headers="headers"
            :hide-headers="basket_active.length === 0"
        >
            <template v-slot:items="props">
                <td class="basket-table__first"><img class="basket-table__img" :src="props.item.PREVIEW_PICTURE"></td>
                <td class="basket-table__text">{{ props.item.PRODUCT_NAME }}</td>
                <td class="basket-table__text" style="padding: 0 12px">{{ props.item.SIZE || props.item.EUSIZE }}</td>
                <td class="basket-table__text">{{ props.item.QUANTITY - props.item.REMAINDER >= 0 ? props.item.REMAINDER : props.item.QUANTITY }}</td>
                <td class="basket-table__text">{{ props.item.FINAL_PRICE }}</td>
                <td class="basket-table__text" @click="delete_item(props.item.PRODUCT_ID)"><v-icon class="delite-item">mdi-close</v-icon></td>
            </template>
            <template v-slot:no-data>
                <div class="basket-table-no-item" :value="true">
                    Ваша корзина пуста
                </div>
            </template>
        </v-data-table>
        <div class="final__price-container">
            <div v-if="basket.PRiCE !== 0 && basket.PRiCE" class="final__price">Итоговая стоимость: <div class="final__price-price">{{ basket.PRiCE }} баллов</div></div>
            <div v-if="point < 0" class="final__price-error">Не хватает: <div class="final__price-error-price">{{ point * -1 }} баллов</div></div>
            <div v-if="basket.PRiCE !== 0 && basket.PRiCE < 400" class="final__price-min">Минимальная стоимость заказа: <div class="final__price-price">400 баллов</div></div>
        </div>
        <div v-if="error_basket.length > 0" class="error-basket">
            <div class="error-basket__header">Недоступные для заказа</div>
            <v-data-table
                :items="error_basket"
                class="basket-table"
                hide-actions
                :headers="headers"
            >
                <template v-slot:items="props">
                    <td class="basket-table__first"><img class="basket-table__img" :src="props.item.PREVIEW_PICTURE"></td>
                    <td class="basket-table__text">{{ props.item.PRODUCT_NAME }}</td>
                    <td class="basket-table__text" style="padding: 0 12px">{{ props.item.SIZE }}</td>
                    <td class="basket-table__text">{{ props.item.ACTIVE ? props.item.QUANTITY - props.item.REMAINDER : props.item.QUANTITY }}</td>
                    <td class="basket-table__text">{{ props.item.FINAL_PRICE }}</td>
                    <td class="basket-table__text" @click="delete_item(props.item.PRODUCT_ID)"><v-icon class="delite-item">mdi-close</v-icon></td>
                </template>
            </v-data-table>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';

export default {
  data() {
    return {
      headers: [
        {
          text    : 'Призы',
          align   : 'left',
          value   : 'PRODUCT_NAME',
          sortable: false,
        },
        {text: '', sortable: false},
        {text: 'Размер', value: 'SIZE', sortable: false},
        {text: 'Кол-во, шт', value: 'QUANTITY', sortable: false},
        {text: 'Стоимость,  баллы', value: 'FINAL_PRICE', sortable: false},
        {text: '', sortable: false},
      ],
      product: '',
    };
  },
  computed: {
    ...mapGetters('order/Basket', ['basket', 'error_basket']),
    point() {
      const user = JSON.parse(localStorage.getItem('user'));
      return user.points - this.basket.PRiCE;
    },
    basket_active() {
      if (this.basket.PRODUCTS) {
        return this.basket.PRODUCTS.filter((item) => item.ACTIVE === true);
      } else {
        return [];
      }
    },
  },
  methods: {
    ...mapActions('order/Basket', ['getBasket']),
    ...mapActions('order/Basket', ['delete_item']),
  },
  mounted() {
    const basket = localStorage.getItem('basket');
    this.getBasket(basket);
  },
};
</script>

<style lang="sass" scoped>
.error-basket
    margin-top: 63px

    &__header
        font-size: 48px
        color: #4A4A4A
        line-height: 58px
        font-weight: 400


.basket-table-no-item
    font-size: 32px
    font-family: 'Futura FuturisC Light'
    line-height: 44px
    font-weight: 300
    color: #4A4A4A
    padding: 20px 0
    cursor: default
    margin: 0 0 0 -20px
.final__price
    display: flex
    flex-direction: row
    color: #E4183E
    font-size: 16px
    line-height: 19px
    font-weight: 400
    align-items: center
    margin-top: 28px
    padding-bottom: 20px
    border-bottom: 1px solid #DEDEDE
    &-min
      display: flex
      align-items: center
      color: #E4183E
      font-size: 16px
      line-height: 19px
      margin-top: 28px
    &-price
        padding-left: 34px
        font-size: 24px
        line-height: 29px

    &-error
      display: flex
      flex-direction: row
      color: #838688
      font-size: 16px
      line-height: 19px
      font-weight: 400
      align-items: center
      margin-top: 28px
      &-price
          font-size: 20px
          color: #231F20
          line-height: 24px
          margin-left: 54px

    &-container
        max-width: 1130px
        width: 100%
        display: flex
        flex-direction: column
        align-items: flex-end
        justify-content: flex-end
</style>
